module.exports = __webpack_public_path__ + "img/tz.ed1c43d0.svg";